import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Brand */}
                <div className="footer-brand">
                    <div className="footer-logo-row">
                        <div className="footer-logo-badge">DG</div>
                        <div className="footer-logo-info">
                            <span className="footer-brand-name">DataGreffe</span>
                            <span className="footer-brand-sub">Annonces Légales - Côte d'Ivoire</span>
                        </div>
                    </div>
                    <p className="footer-brand-desc">
                        Plateforme officielle de consultation des annonces légales publiées
                        en Côte d'Ivoire. Recherchez facilement les informations sur les
                        entreprises enregistrées.
                    </p>
                </div>

                {/* Navigation */}
                <div className="footer-col">
                    <h4 className="footer-col-title">Navigation</h4>
                    <ul className="footer-col-links">
                        <li><Link to="/">Accueil</Link></li>
                        <li><Link to="/Loisresult">Rechercher</Link></li>
                        <li><a href="https://datagreffe.ci/aide">Aide</a></li>
                    </ul>
                </div>

                {/* Légal */}
                <div className="footer-col">
                    <h4 className="footer-col-title">Légal</h4>
                    <ul className="footer-col-links">
                        <li><a href="https://datagreffe.ci/mentions-legales">Mentions légales</a></li>
                        <li><a href="https://datagreffe.ci/politique-confidentialite">Politique de confidentialité</a></li>
                        <li><a href="https://datagreffe.ci/cgu">CGU</a></li>
                    </ul>
                </div>
            </div>

            <div className="footer-bottom">
                <p>© 2026 DataGreffe - Côte d'Ivoire. Tous droits réservés.</p>
            </div>
        </footer>
    );
};

export default Footer;